@if ({ items: handler().items$ | async }; as resolved) {
  <div
    class="absolute right-0 top-0 z-10 w-full"
    [class.hidden]="!(filterQuery.value && dropdown?.overlayVisible)"
    (click)="$event.stopPropagation()">
    <span class="p-input-icon-left w-full">
      <div class="absolute top-1/2 mt-[3px] -translate-y-1/2 translate-x-2 select-none">
        <svg-icon
          key="search"
          size="lg"
          color="default"></svg-icon>
      </div>
      <input
        #searchInput
        pInputText
        type="text"
        class="p-inputtext-sm w-full rounded-lg border-0 bg-white placeholder:text-zinc-400"
        [placeholder]="handler().options.filter.filterPlaceholder || 'i18n.Common.search' | translate"
        [formControl]="filterQuery" />
    </span>
  </div>

  <p-dropdown
    #dropDown
    class="first-child-size-full flex size-full items-center"
    [appendTo]="'body'"
    [autoOptionFocus]="false"
    [placeholder]="placeholder() || 'i18n.Common.selectOption' | translate"
    [options]="getOptions | call: resolved.items"
    [showClear]="handler().options.showClear"
    [virtualScroll]="handler().options.virtualScroll ? true : false"
    [virtualScrollItemSize]="handler().options.templateOptions.itemSize"
    [virtualScrollOptions]="handler().virtualScrollerOptions"
    [scrollHeight]="handler().options.templateOptions.scrollHeight + 'px'"
    [panelStyleClass]="'smart-input-entity-overlay' + ((handler().processing$ | async) ? 'processing' : '')"
    [formControl]="control()"
    (ngModelChange)="onModelChange($event)"
    (onShow)="onShow()"
    (onHide)="onHide()">
    @if (handler().options.filter.enabled) {
      <ng-template pTemplate="footer">
        @if (resolved.items?.length === 0) {
          <div class="-mt-2 pb-1 pl-3">
            <span class="text-xs italic">{{ 'i18n.Common.noItemsFound' | translate }}</span>
          </div>
        }
      </ng-template>
    }

    <!-- selectedItem -->
    <ng-template pTemplate="selectedItem">
      @if (control().value; as item) {
        @if (selectedItemTemplate) {
          <ng-container
            [ngTemplateOutlet]="selectedItemTemplate"
            [ngTemplateOutletContext]="{ item }"></ng-container>
        } @else if (itemTemplate) {
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item }"></ng-container>
        } @else {
          <app-avatar
            class="flex items-center"
            [showName]="true"
            [name]="item ? item : '-'"></app-avatar>
        }
      }
    </ng-template>

    <!-- ListItem -->
    <ng-template
      let-item
      pTemplate="item">
      @if (item) {
        @if (cast(item); as entity) {
          @if (itemTemplate) {
            <ng-container
              [ngTemplateOutlet]="itemTemplate"
              [ngTemplateOutletContext]="{ item: entity }"></ng-container>
          } @else {
            <app-avatar
              [showName]="true"
              [name]="item ? item : '-'"></app-avatar>
          }
        } @else {
          <div class="flex items-center gap-2">
            <div class="size-6 animate-pulse rounded-md bg-slate-100"></div>
            <div class="h-4 w-1/3 animate-pulse rounded-full bg-slate-100"></div>
          </div>
        }
      } @else {
        <div class="flex items-center gap-2">
          <div class="size-6 animate-pulse rounded-md bg-slate-100"></div>
          <div class="h-4 w-1/3 animate-pulse rounded-full bg-slate-100"></div>
        </div>
      }
    </ng-template>
  </p-dropdown>
}
